module.exports = __webpack_public_path__ + "media/img/pages/profile/migros ger 2-617968e4b79a02171fee1be9d1e3e3b5.jpg";